import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideFinancialYearOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="年度管理"
      description="年度データの登録と年度選択機能を提供します。年度データはセキュリティチェックや契約管理の期間指定に使用されます。ADMIN権限のユーザーのみ操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="financial-year/register">年度を管理する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              年度データの登録・管理を行います。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideFinancialYearOverview;
